import type { WarehouseArea, WarehouseAreaOutputList } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const formatWarehouseLabel = (warehouseArea: WarehouseArea | WarehouseAreaOutputList): string => {
  return `${warehouseArea.externalSystemId} ${warehouseArea.location!.description}`
}

export const getWarehouseOptions = (warehouses: (WarehouseArea | WarehouseAreaOutputList)[]): Option<string>[] => {
  return warehouses
    .map((warehouse) => ({
      value: warehouse.warehouseAreaId,
      label: formatWarehouseLabel(warehouse),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
